/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useRef, useState, useEffect } from "react";
import {
  createBankSchema,
  createStatutorySchema,
  createStatutorySchemaEPF,
} from "./statutory-kyc-validation";
import { logger } from "../../../utils/logger";
import useAPIHandler from "../../../hook/use-api-handler";
import { useToast } from "../../../context/toast-context";
import { EPF_API } from "../../statutory/epf/epf-constant";
import { useNavigate, useParams } from "react-router-dom";
import { STATUTORY_KYC_CONST } from "./statutory-kyc-const";
import { ESI_API } from "../../statutory/esi/esi-constant";
import { formatToYYYYMMDD } from "../../../utils/common";

export const EmployeeStatutoryKYCinfo = () => {
  const { fetchData } = useAPIHandler();
  const navigate = useNavigate();
  const { id } = useParams();

  const { showToastMessage } = useToast();

  const initial_epf_value = {
    epf_availability: false,
    member_payroll: null,
    epf_id_ac_no: "",
    uan_no: "",
    ppo_no: "",
    employee_contribution: "",
    retired_govt_employee: null,
    epf_registration_date: "",
    epf_uan_attachment: "",
  };

  const initialBankDetails = {
    bank_name: "",
    branch_name: "",
    account_number: "",
    ifsc_code: "",
    payment_through: "",
  };

  const fileInputRef = useRef(null);
  const [EmployeeESCI, setEmployeeESCI] = useState({});
  const [EmployeeEPF, setEmployeeEPF] = useState(initial_epf_value);
  const [bankdetails, setBankdetails] = useState(initialBankDetails);
  const [alldocs, setAlldocs] = useState([]);
  const [docs, setDocs] = useState({});
  const [orginfoESCI, setOrginfoESCI] = useState({});
  const [orginfo, setOrginfo] = useState({});
  const [employeeInfo, setEmployeeInfo] = useState({});
  const [errorsESCI, setErrorsESCI] = useState({});
  const [errorsEPF, setErrorsEPF] = useState({});
  const [errorBank, setErrorBank] = useState({});
  const [updateLoder, setUpdateloader] = useState(false);

  // Modals
  const UpdateAllData = () => {
    setEmployeeESCI({
      esi_availability: employeeInfo?.data?.esi_availability,
      esic_card_attachment: employeeInfo?.data?.esic_card_attachment,
      esic_insurance_number: employeeInfo?.data?.esic_insurance_number,
      esic_registration_date: formatToYYYYMMDD(
        new Date(employeeInfo?.data?.esic_registration_date)
      ),
    });
    setEmployeeEPF({
      epf_availability: employeeInfo?.data?.epf_availability,
      member_payroll: employeeInfo?.data?.member_payroll,
      epf_id_ac_no: employeeInfo?.data?.epf_id_ac_no,
      uan_no: employeeInfo?.data?.uan_no,
      ppo_no: employeeInfo?.data?.ppo_no,
      employee_contribution: employeeInfo?.data?.employee_contribution,
      retired_govt_employee: employeeInfo?.data?.retired_govt_employee,
      epf_registration_date: formatToYYYYMMDD(
        new Date(employeeInfo?.data?.epf_registration_date)
      ),
      epf_uan_attachment: employeeInfo?.data?.epf_uan_attachment,
    });

    setBankdetails({
      bank_name: employeeInfo?.data?.bank_name,
      branch_name: employeeInfo?.data?.branch_name,
      account_number: employeeInfo?.data?.account_number,
      ifsc_code: employeeInfo?.data?.ifsc_code,
      payment_through: employeeInfo?.data?.payment_through,
    });
    setAlldocs(employeeInfo?.data?.kyc_additional_info);
  };

  const [escimodal, setEscimodal] = useState(false);
  const [epfmodal, setEpfmodal] = useState(false);
  const [bankmodal, setBankmodal] = useState(false);
  const [kycModal, setkycModal] = useState(false);

  const TogggleEsciMOdal = () => {
    if (!escimodal) {
      UpdateAllData();
    }
    setEscimodal(!escimodal);
  };
  const TogggleEpfMOdal = () => {
    if (!epfmodal) {
      UpdateAllData();
    }
    setEpfmodal(!epfmodal);
  };

  const ToggleBank = () => {
    UpdateAllData();
    setBankmodal(!bankmodal);
  };

  const ToggleKycModal = () => {
    if (!kycModal) {
      UpdateAllData();
    }
    setkycModal(!kycModal);
  };

  const checkDocName = (val) => {
    const temp = alldocs.map((item) => item.document_type);
    return temp.includes(val);
  };
  function getEpfFn() {
    const URL = EPF_API.EPF_LIST.URL;
    const METHOD = EPF_API.EPF_LIST.METHOD;
    const payload = {
      url: URL,
      METHOD,
    };

    try {
      fetchData(payload)
        .then((res) => {
          const resData = res?.data || {};
          setOrginfo(resData);
          setEmployeeEPF({ ...EmployeeEPF });
        })
        .catch((err) => {
          logger.log(err);
        });
    } catch (error) {
      logger.log(error);
    }
  }

  function getESCIFn() {
    const URL = ESI_API.ESI_LIST.URL;
    const METHOD = ESI_API.ESI_LIST.METHOD;
    const payload = {
      url: URL,
      METHOD,
    };

    try {
      fetchData(payload)
        .then((res) => {
          const resData = res?.data || {};
          setOrginfoESCI(resData);
          setEmployeeESCI({ ...EmployeeESCI });
        })
        .catch((err) => {
          logger.log(err);
        });
    } catch (error) {
      logger.log(error);
    }
  }

  function EmployeeInformation() {
    const payload = {
      url: `/employee/statutory/${id}`,
      METHOD: "GET",
    };
    try {
      fetchData(payload)
        .then((res) => {
          const resData = res || {};
          setEmployeeInfo(resData);
        })
        .catch((err) => {
          logger.log(err);
        });
    } catch (error) {
      logger.log(error);
    }
  }

  useEffect(() => {
    if (docs?.document_type && docs?.document_number && docs?.attachment) {
      const temp = [...alldocs, docs];
      setAlldocs(temp);
      setDocs({});
    }
  }, [
    docs?.document_type,
    docs?.document_number,
    docs?.attachment,
    alldocs,
    docs,
  ]);
  logger.log("alldocs", alldocs);

  useEffect(() => {
    getEpfFn();
    getESCIFn();
    EmployeeInformation();
  }, []);
  // toggle function
  const ToggleEsci = () => {
    setErrorsESCI({});

    if (EmployeeESCI?.esi_availability) {
      setEmployeeESCI({
        ...EmployeeESCI,
        ["esi_availability"]: !EmployeeESCI["esi_availability"],
        esic_insurance_number: "",
        esic_registration_date: "",
        esic_card_attachment: "",
      });
    } else {
      setEmployeeESCI({
        ...EmployeeESCI,
        ["esi_availability"]: !EmployeeESCI["esi_availability"],
      });
    }
  };
  const ToggleEPF = () => {
    let temp = {};
    setErrorsEPF({});
    if (EmployeeEPF["epf_availability"]) {
      temp = {
        ...initial_epf_value,
        ["epf_availability"]: !EmployeeEPF["epf_availability"],
      };
      setEmployeeEPF(temp);
    } else {
      temp = {
        ...EmployeeEPF,
        ["epf_availability"]: !EmployeeEPF["epf_availability"],
      };
      setEmployeeEPF(temp);
    }
  };
  // onChnage function
  const onChnageESCI = (e, name, type) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (type === "file") {
      value = e.target.files[0];
    }
    if (STATUTORY_KYC_CONST[name]?.customOptions) {
      value = STATUTORY_KYC_CONST[name]?.customOptions?.formatValueFn(
        value,
        EmployeeESCI
      );
    }

    const updateempEsci = {
      ...EmployeeESCI,
      [name]: value,
    };

    setEmployeeESCI(updateempEsci);

    const schema = createStatutorySchema();

    const { error } = schema.validate(updateempEsci, {
      abortEarly: false,
    });

    if (!error) {
      setErrorsESCI((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    } else {
      const fieldError = error.details.find((err) => err.path[0] === name);
      setErrorsESCI((prevErrors) => ({
        ...prevErrors,
        [name]: fieldError ? fieldError.message : undefined,
      }));
    }
  };
  const onChanageEPF = (e, name, type) => {
    let value = e;
    if (e && e.target && type === undefined) {
      value = e.target.value;
    }
    if (type === "file") {
      value = e.target.files[0];
    }

    if (STATUTORY_KYC_CONST[name]?.customOptions) {
      value = STATUTORY_KYC_CONST[name]?.customOptions?.formatValueFn(
        value,
        EmployeeEPF
      );
    }

    const updatedEmployeeEPF = {
      ...EmployeeEPF,
      [name]: value,
    };

    setEmployeeEPF(updatedEmployeeEPF);

    const schema = createStatutorySchemaEPF();

    const { error } = schema.validate(updatedEmployeeEPF, {
      context: {
        epf_availability: updatedEmployeeEPF?.epf_availability,
        retired_govt_employee: updatedEmployeeEPF?.retired_govt_employee,
      },
      abortEarly: false,
    });

    if (!error) {
      setErrorsEPF((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    } else {
      const fieldError = error.details.find((err) => err.path[0] === name);
      setErrorsEPF((prevErrors) => ({
        ...prevErrors,
        [name]: fieldError ? fieldError.message : undefined,
      }));
    }
  };
  const onChangeBank = (e, name) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (STATUTORY_KYC_CONST[name]?.customOptions) {
      value = STATUTORY_KYC_CONST[name]?.customOptions?.formatValueFn(
        value,
        bankdetails
      );
    }
    const updateBankDetails = {
      ...bankdetails,
      [name]: value,
    };

    setBankdetails(updateBankDetails);

    // const schema = createBankSchema();

    // const { error } = schema.validate(updateBankDetails, {

    //   abortEarly: false,
    // });

    // if (!error) {
    //   setErrorBank((prevErrors) => ({
    //     ...prevErrors,
    //     [name]: undefined,
    //   }));
    // } else {
    //   const fieldError = error.details.find((err) => err.path[0] === name);
    //   setErrorBank((prevErrors) => ({
    //     ...prevErrors,
    //     [name]: fieldError ? fieldError.message : undefined,
    //   }));
    // }
  };
  const onChangeKYCdoc = (e, name, type) => {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (type === "file") {
      value = e.target.files[0];
    }
    setDocs({
      ...docs,
      [name]: value,
    });
  };

  // onBlure
  const OnBlureESCI = (e, name) => {
    const { value } = e.target;
    const updatedESCI = {
      ...EmployeeESCI,
      [name]: value,
    };
    const { error } = createStatutorySchema().validate(updatedESCI, {
      abortEarly: false,
    });

    if (error) {
      const fieldError = error.details.find((err) => err.path[0] === name);
      if (fieldError) {
        setErrorsESCI((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError.message,
        }));
      } else {
        setErrorsESCI((prevErrors) => {
          const { [name]: removedError, ...restErrors } = prevErrors;
          return restErrors;
        });
      }
    } else {
      setErrorsESCI((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const OnBlureEPF = (e, name) => {
    const { value } = e.target;
    const updateEPF = {
      ...EmployeeEPF,
      [name]: value,
    };
    const { error } = createStatutorySchemaEPF().validate(updateEPF, {
      abortEarly: false,
    });

    if (error) {
      const fieldError = error.details.find((err) => err.path[0] === name);
      if (fieldError) {
        setErrorsEPF((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError.message,
        }));
      } else {
        setErrorsEPF((prevErrors) => {
          const { [name]: removedError, ...restErrors } = prevErrors;
          return restErrors;
        });
      }
    } else {
      setErrorsEPF((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };
  // const OnBlureBank = (e, name) => {
  //   const { value } = e.target;
  //   const updateEPF = {
  //     ...bankdetails,
  //     [name]: value,
  //   };
  //   const { error } = createBankSchema().validate(updateEPF, { abortEarly: false });

  //   if (error) {

  //     const fieldError = error.details.find((err) => err.path[0] === name);
  //     if (fieldError) {
  //       setErrorBank((prevErrors) => ({
  //         ...prevErrors,
  //         [name]: fieldError.message,
  //       }));
  //     } else {
  //       setErrorBank((prevErrors) => {
  //         const { [name]: removedError, ...restErrors } = prevErrors;
  //         return restErrors;
  //       });
  //     }
  //   } else {
  //     setErrorBank((prevErrors) => {
  //       const { [name]: removedError, ...restErrors } = prevErrors;
  //       return restErrors;
  //     });
  //   }
  // }
  // validation
  const validateESCI = () => {
    const { error } = createStatutorySchema().validate(EmployeeESCI, {
      abortEarly: false,
    });
    if (error) {
      const newErrors = {};
      error.details.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });
      setErrorsESCI(newErrors);
      return false;
    }
    setErrorsESCI({});

    return true;
  };

  const validateEPF = () => {
    if (!EmployeeEPF?.member_payroll) {
      delete EmployeeEPF?.epf_id_ac_no;
    }

    const { error } = createStatutorySchemaEPF().validate(EmployeeEPF, {
      abortEarly: false,
    });

    if (error) {
      const newErrors = {};
      error.details.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });

      setErrorsEPF(newErrors);
      return false;
    }
    setErrorsEPF({});

    return true;
  };

  // const validateBank = () => {
  //   const { error } = createBankSchema().validate(bankdetails, { abortEarly: false });
  //   if (error) {
  //     const newErrors = {};
  //     error.details.forEach((err) => {
  //       newErrors[err.path[0]] = err.message;
  //     });
  //     setErrorBank(newErrors);
  //     return false;
  //   }
  //   setErrorBank({});
  //   return true;
  // };

  // submit function
  const SubmitData = async (val) => {
    setErrorsESCI({});
    setErrorsEPF({});
    setErrorBank({});
    let validate = false;
    if (EmployeeESCI?.esi_availability) {
      validate = validateESCI();
    }
    if (EmployeeEPF?.epf_availability) {
      validate = validateEPF();
    }
    if (validate) {
      const data = {
        esi_availability: EmployeeESCI?.esi_availability
          ? EmployeeESCI?.esi_availability
          : false,
        esic_insurance_number: EmployeeESCI?.esic_insurance_number,
        esic_registration_date: EmployeeESCI?.esic_registration_date,
        esic_card_attachment: EmployeeESCI?.esic_card_attachment,
        epf_availability: EmployeeEPF?.epf_availability,
        member_payroll: EmployeeEPF?.member_payroll,
        epf_id_ac_no: EmployeeEPF?.epf_id_ac_no,
        uan_no: EmployeeEPF?.uan_no,
        ppo_no: EmployeeEPF?.ppo_no,
        employee_contribution: EmployeeEPF?.employee_contribution,
        retired_govt_employee: EmployeeEPF?.retired_govt_employee,
        epf_registration_date: EmployeeEPF?.epf_registration_date,
        epf_uan_attachment: EmployeeEPF?.epf_uan_attachment,
        bank_name: bankdetails?.bank_name,
        branch_name: bankdetails?.branch_name,
        account_number: bankdetails?.account_number,
        ifsc_code: bankdetails?.ifsc_code,
        payment_through: bankdetails?.payment_through,
        kyc_additional_info: alldocs,
      };
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        const value = data[key];

        if (value === undefined || value === null || value === "") {
          return;
        }

        if (key === "kyc_additional_info" && Array.isArray(value)) {
          value.forEach((item, index) => {
            Object.keys(item).forEach((subKey) => {
              const subValue = item[subKey];

              if (
                subValue === undefined ||
                subValue === null ||
                subValue === ""
              ) {
                return;
              }

              formData.append(`${key}[${index}][${subKey}]`, subValue);
            });
          });
        } else if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      });

      try {
        const res = await fetchData({
          data: formData,
          url: `employee/statutory/${id}`,
          method: "POST",
        });

        if (res?.data) {
          if (val === "save") {
            navigate("/employee-list");
          }
          if (val === "next") {
            navigate(`/employee/PayAndBenefits/${id}`);
          }
        }
      } catch (error) {
        showToastMessage({
          message: "Something went wrong!",
          color: "danger",
        });
      }
    }
  };

  const UpdateStatutory = async () => {
    setUpdateloader(true);
    setErrorsESCI({});
    setErrorsEPF({});
    setErrorBank({});
    let validate = false;
    if (EmployeeESCI?.esi_availability) {
      validate = validateESCI();
    }
    if (EmployeeEPF?.epf_availability) {
      validate = validateEPF();
    }
    logger.log("validate", validate);
    if (validate) {
      const data = {
        esi_availability: EmployeeESCI?.esi_availability
          ? EmployeeESCI?.esi_availability
          : false,
        esic_insurance_number: EmployeeESCI?.esic_insurance_number,
        esic_registration_date: EmployeeESCI?.esic_registration_date,
        esic_card_attachment: EmployeeESCI?.esic_card_attachment,
        epf_availability: EmployeeEPF?.epf_availability,
        member_payroll: EmployeeEPF?.member_payroll,
        epf_id_ac_no: EmployeeEPF?.epf_id_ac_no,
        uan_no: EmployeeEPF?.uan_no,
        ppo_no: EmployeeEPF?.ppo_no,
        employee_contribution: EmployeeEPF?.employee_contribution,
        retired_govt_employee: EmployeeEPF?.retired_govt_employee,
        epf_registration_date: EmployeeEPF?.epf_availability
          ? EmployeeEPF?.epf_registration_date
          : "",
        epf_uan_attachment: EmployeeEPF?.epf_uan_attachment,
        bank_name: bankdetails?.bank_name,
        branch_name: bankdetails?.branch_name,
        account_number: bankdetails?.account_number,
        ifsc_code: bankdetails?.ifsc_code,
        payment_through: bankdetails?.payment_through,
        kyc_additional_info: alldocs,
      };

      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        const value = data[key];

        if (value === undefined || value === null || value === "") {
          return;
        }

        if (key === "kyc_additional_info" && Array.isArray(value)) {
          value.forEach((item, index) => {
            Object.keys(item).forEach((subKey) => {
              const subValue = item[subKey];

              if (
                subValue === undefined ||
                subValue === null ||
                subValue === ""
              ) {
                return;
              }

              formData.append(`${key}[${index}][${subKey}]`, subValue);
            });
          });
        } else if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      });

      try {
        const res = await fetchData({
          data: formData,
          url: `employee/statutory/${id}/update/${employeeInfo?.data?.employee_statutory_id}`,
          method: "PUT",
        });
        if (res) {
          showToastMessage({
            message: "Information Updated",
            color: "success",
          });
          setEscimodal(false);
          setEpfmodal(false);
          setBankmodal(false);
          setkycModal(false);
          setUpdateloader(false);
          getEpfFn();
          getESCIFn();
          EmployeeInformation();
        }
      } catch (error) {
        setUpdateloader(false);
        showToastMessage({
          message: "Something went wrong!",
          color: "danger",
        });
      }
    } else {
      setUpdateloader(false);
    }
  };
  // kyc doc upload
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setDocs({ ...docs, ["attachment"]: selectedFile });
    }
  };

  //delete file from particuler index
  const DeleteSpecificFile = (pos) => {
    const temp = alldocs?.filter((index, id) => {
      if (id !== pos) {
        return index;
      }
    });
    setAlldocs(temp);
  };

  //open file in a newTab
  function openFileInNewTab(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  }



  return {
    orginfo,
    orginfoESCI,
    fileInputRef,
    EmployeeESCI,
    onChnageESCI,
    OnBlureESCI,
    ToggleEsci,
    errorsESCI,
    EmployeeEPF,
    onChanageEPF,
    OnBlureEPF,
    ToggleEPF,
    errorsEPF,
    bankdetails,
    onChangeBank,
    // OnBlureBank,
    errorBank,
    handleButtonClick,
    handleFileChange,
    docs,
    alldocs,
    checkDocName,
    DeleteSpecificFile,
    onChangeKYCdoc,
    openFileInNewTab,
    SubmitData,
    UpdateStatutory,
    employeeInfo,
    escimodal,
    TogggleEsciMOdal,
    epfmodal,
    TogggleEpfMOdal,
    bankmodal,
    ToggleBank,
    kycModal,
    ToggleKycModal,
    updateLoder,
  };
};
